module.exports = __webpack_public_path__ + "static/media/ic_ziping.e2b6d715.svg";